/* eslint-disable no-console */
import io from 'socket.io-client';
import config from '../constants/configs';
import * as socketActions from '../constants/actionTypes/sockets';
import { ERR_RTE_GENERIC } from '../constants/Errors';

const allActions = Object.values(socketActions);

const plans = {
    IC_LEGACY: [
        socketActions.SOCKET,
        socketActions.RECONNECT,
        socketActions.RECONNECT_ATTEMPT,
        socketActions.RECONNECT_ERROR,
        socketActions.DISCONNECT,
        socketActions.UPDATE_CONNECTED_CLIENTS,
        socketActions.DRAFT_OPENED,
    ],
    IC_ESSENTIAL: allActions,
    IC_POWER: allActions,
    IC_ENTERPRISE: allActions,
    IC_STARTER: allActions,
    IC_BUSINESS: allActions,
    IC_SBENTERPRISE: allActions,
};

const connectionsOptions = {
    reconnectionAttempts: 2,
    reconnectionDelay: 500,
    reconnectionDelayMax: 500,
};

/**
 * The only place to load and manage to socket connection.
 * We wrap the sockets middleware inside another function that takes in the one instance of this class.
 * This lets us interact with the socket inside the middleware.
 */
export default class SocketClient {
    socket;

    plan;

    /**
     * Makes the initial socket connection and attempts to authenticate
     * @param {string} jwt User's JWT
     * @param {string} plan Account plan user is on
     */
    connect(jwt, plan) {
        this.socket = io.connect(config.websockets, connectionsOptions);
        this.plan = plan;
        return new Promise((resolve, reject) => {
            this.socket.on('connect', () => {
                this.socket
                    .emit('authenticate', { token: jwt })
                    .on('authenticated', () => resolve())
                    .on('unauthorized', (err) => {
                        console.error('unauthorized', err);
                        reject(new Error(ERR_RTE_GENERIC));
                    });
            });
            this.socket.on('connect_error', (err) => {
                console.error('connect_error:', err);
                reject(new Error(ERR_RTE_GENERIC));
            });
        });
    }

    /**
     * Disconnects the user from the socket server
     */
    disconnect() {
        return new Promise((resolve, reject) => {
            if (!this.socket) {
                reject(new Error(ERR_RTE_GENERIC));
                return;
            }
            this.socket.disconnect();
            this.socket = null;
            resolve();
        });
    }

    /**
     * Emits events and data to the socket server
     * @param {string} event The name of the event to emit
     * @param {any} data Any data to be sent to the server
     */
    emit(event, data) {
        if (!plans[this.plan].includes(event)) {
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            if (!this.socket) {
                return reject(new Error(ERR_RTE_GENERIC));
            }
            return this.socket.emit(event, data, (res) => {
                if (res.error) {
                    return reject(res.error);
                }
                return resolve();
            });
        });
    }

    /**
     * Adds a listener for an event emitted from the server
     * @param {string} event The name of the event to listen for
     * @param {function} callback The function to run when receiving this event
     */
    on(event, callback) {
        if (!plans[this.plan].includes(event)) {
            return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
            if (!this.socket) {
                reject(new Error(ERR_RTE_GENERIC));
                return;
            }
            this.socket.on(event, callback);
            resolve();
        });
    }
}
